import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/core/styles';
import {
  Snackbar,
  SnackbarContent,
} from '@material-ui/core/';
import { 
                                                                                    // amber,
  green,
} from '@material-ui/core/colors';
                                                                                      // import Save from '@material-ui/icons/Save';
                                                                                      // import InfoIcon from '@material-ui/icons/Info';
                                                                                      // import WarningIcon from '@material-ui/icons/Warning';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';

const variantIcon = {
  success: CheckCircleIcon,
                                                                                      // warning: WarningIcon,
                                                                                      // info: InfoIcon,
};

const useStyleSavedNotification = makeStyles(theme => ({
  success: {
    backgroundColor: green[600],
                                                                                      // backgroundColor: theme.palette.primary.main,
  },

                                                                                      // info: {
                                                                                      //   backgroundColor: theme.palette.primary.main,
                                                                                      // },
                                                                                      // warning: {
                                                                                      //   backgroundColor: amber[700],
                                                                                      // },

  icon: {
    fontSize: 20,
  },
  iconVariant: {
    opacity: 0.9,
    marginRight: theme.spacing(1),
  },
  message: {
    fontSize: 16,
    display: 'flex',
    alignItems: 'center',
  },
}));

export default function SnackbarContentSavedNotification(props) {
  const classes = useStyleSavedNotification();
  const { className, message, onClose, variant, ...other } = props;
  const Icon = variantIcon[variant];
  const [state] = React.useState({
    open: true,
    vertical: 'top',
    horizontal: 'center',
  });
  const { vertical, horizontal, open } = state;
  return (
    <Snackbar
                                                                                        // onClose={() => {this.setState({showSnackbar: false})}}
                                                                                        // open={this.state.showSnackbar}
      autoHideDuration={1500}
      anchorOrigin={{
        vertical: 'top',
        horizontal: 'center',
      }}
      open={open}
      className={clsx(classes[variant], className)}
      key={`${vertical},${horizontal}`}
      >
      <SnackbarContent 
                                                                                  // className={clsx(classes[variant], className)}
        style={{
                                                                                            // backgroundColor:'#00ff00',
          backgroundColor:'green',
        }}

        aria-describedby="snackbar-save-notification"
        message={
          <span 
            id="snackbar-save-notification" 
            className={classes.message}
          >
            <Icon className={clsx(classes.icon, classes.iconVariant)} />
            {props.message}
          </span>
        }
        {...other}
      />
    </Snackbar>
  );
}
SnackbarContentSavedNotification.propTypes = {
  className: PropTypes.string,
  message: PropTypes.string,
  onClose: PropTypes.func,
                                                                                  // variant: PropTypes.oneOf(['success']).isRequired,
  variant: PropTypes.oneOf(['error']).isRequired,
};